module.exports = __webpack_public_path__ + "assets/img/Australian-Institute-of-Fitness-Website-w720.e1917c59.webp";